import {
    FetchPayrollHistory,
    FetchNotEnrolledPayroll
} from "../actions/action";

const initialState = {
    fetchPayrollHistory:[],
    fetchNotEnrolledPayroll: [],
};

const payrollReducer = (state = initialState, action) => {
    switch (action.type) {
        case "FETCH_PAYROLLHISTORY":
            return {
                ...state,
                fetchPayrollHistory: action.data,
            };
        case "FETCH_NOT_ENROLLED_PAYROLL":
            return {
                ...state,
                fetchNotEnrolledPayroll: action.data,
            };
        default:
            return { ...state };
    }
}

export default payrollReducer;